module.exports = __webpack_public_path__ + "img/Image20230731162802.5273ebc6.png";